//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../shared/services/api";



//--------------- FUNÇÃO ASSÍNCRONA ENABLE USER SERVICE ---------------//
// Responsável por requisitar à API a Ativação do Usuário
export default async function enableUserService(id) {
    try {
        await api.patch(`/usuarios/${id}/ativar`);
        return true;
    } catch (err) {
        return false;
    }
}